export class User {
    clientId: number | undefined;
    displayName: string | undefined;
    emailOrPhoneNumber: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    preferredLanguage: string | undefined;
    preferredLanguageId: number | undefined;
    receivesNotifications: boolean | undefined;
    userId: number | undefined;

    constructor(options?: Partial<User>) {
        Object.assign(this, options);
    }
}
